<!-- 登录页 -->
<style>
    body{
        background:none;
    }
    .login-bg{
        background: url(@/assets/images/login/bg08.jpg) no-repeat 0 0/cover;
        animation: bg-slide 1.5s linear infinite backwards;
    }
    @keyframes bg-slide {
    0%{
        background: url(@/assets/images/login/bg01.jpg) no-repeat 0 0/cover;
    }
    14.2%{
        background: url(@/assets/images/login/bg02.jpg) no-repeat 0 0/cover;
    }
    28.4%{
        background: url(@/assets/images/login/bg03.jpg) no-repeat 0 0/cover;
    }
    42.6%{
        background: url(@/assets/images/login/bg04.jpg) no-repeat 0 0/cover;
    }
    56.8%{
        background: url(@/assets/images/login/bg05.jpg) no-repeat 0 0/cover;
    }
    71%{
        background: url(@/assets/images/login/bg06.jpg) no-repeat 0 0/cover;
    }
    85.2%{
        background: url(@/assets/images/login/bg07.jpg) no-repeat 0 0/cover;
    }
    100%{
        background: url(@/assets/images/login/bg08.jpg) no-repeat 0 0/cover;
    }
}
    .verify-wrap{
        height: 2.373rem;
    }
    .verify-msg{
        display:none;
    }
    .suc-drag-btn>.bi-suit-spade-fill{
        display: none;
    }
    .bi-check-circle-fill{
        display: none;
        color: #7ac23c;
    }
    .suc-drag-btn>.bi-check-circle-fill{
        display: initial;
    }
    .drag-progress,.verify-msg{
        background: #7ac23c;
    }
    .language-more{
        -webkit-transition: all .3s cubic-bezier(.25, 1.15, .35, 1.15);
        -moz-transition: all .3s cubic-bezier(.25, 1.15, .35, 1.15);
        -o-transition: all .3s cubic-bezier(.25, 1.15, .35, 1.15);
        -ms-transition: all .3s cubic-bezier(.25, 1.15, .35, 1.15);
        transition: all .3s cubic-bezier(.25, 1.15, .35, 1.15);
        opacity: 0;
        transform: translateY(-20px);
    }
    .language-more.active{
        opacity: 1;
        transform: translateY(0px);
    }
    .cursor-move{
        cursor: move;
    }
    .text-discolor{
        color: green;
        position: relative;
        /* background: linear-gradient(90deg, #fff 0%, green 100%);
        background-clip: text; */
    }
    .text-discolor::before{
        content: attr(text);
        position: absolute;
        color: #fff;
        mask-image: linear-gradient(90deg, #fff 0%, transparent 100%);
        animation:text-discolor 2s infinite;
    }
    .bi[class^="bi-fullscreen"]::before{
        font-weight: bold !important;
    }

    /* 字体逐一变色特效 */
    @keyframes text-discolor{
        0%{
            mask-image: linear-gradient(90deg, #fff 0%, transparent 100%);
        }
        10%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 10%, transparent 100%);
        }
        20%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 20%, transparent 100%);
        }
        30%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 30%, transparent 100%);
        }
        40%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 40%, transparent 100%);
        }
        50%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 50%, transparent 100%);
        }
        50%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 60%, transparent 100%);
        }
        70%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 70%, transparent 100%);
        }
        80%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 80%, transparent 100%);
        }
        90%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 90%, transparent 100%);
        }
        100%{
            mask-image: linear-gradient(90deg, transparent 0%, #fff 100%);
        }
    }
    .rail{
        height: 21.8%;
        width: 100%;
        background: url(@/assets/images/login/rail.png) no-repeat;
        background-size: cover;
    }
    .rail-buttom{
        height: 21.8%;
        width: 100%;
        background: url(@/assets/images/login/railButtom.png) no-repeat;
        background-size: cover;
    }
    .login-box{
        background:url(@/assets/images/login/loginbj.png) no-repeat;
        background-size: 100% 100%;
    }
    .login-lbl{
        font-weight: bold;
        color: #E9BC68;
        vertical-align: middle;
        white-space: nowrap;
    }
    .newgame{
        background-color: #FCCA41;
        border-bottom-left-radius: 12px;
        border-bottom-right-radius: 12px;
    }
    .text-game{
        background: linear-gradient(90deg,#690205 0%,#CB2A0B 50%,#670104 100%);
        border-radius: 5px;
        border:1px solid #FC630B;
        font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    }
    .goNewGame{
        background: linear-gradient(90deg,#32BC27 0%,#F5F976 50%,#32BC27 100%);
        border-radius: 2rem !important;
        color: #C5190E !important;
    }
    button, input, optgroup, select, textarea {
        font-family: "黑体", SimHei, sans-serif !important;
    }
</style>
<template>
    <div class=" login-bg d-flex flex-column h-100 justify-content-center position-relative">
        <div class="rail position-absolute top-0"></div>
        <!-- 功能框 -->
        <div class="position-absolute top-2rem start-2rem index-1">
            <!-- 全屏 -->
            <button class="btn bg-dark bg-opacity-75 text-light mb-2 d-flex align-items-center" type="button" @click="$root.setFullscreen">
                <i :class="[isFullscreen?'bi-fullscreen-exit':'bi-fullscreen']" class="bi d-flex" role="button"></i>
                <span class="ms-1 fw-bold">{{isFullscreen?$t("login.unFullscreen"):$t("login.fullscreen")}}</span>
            </button>
            <!-- 语言选择 -->
            <choose-lang></choose-lang>
        </div>
        <!-- 登录框 -->
        <div class="d-flex justify-content-end flex-grow-1 align-items-center">
            <div class="login-box bg-opacity-65 rounded-5 me-4 d-flex flex-column" style="width: 38.9%;height: 46%; margin-top: 9rem; z-index: 99;">
                <form class="px-xxl-5 pt-xxl-4 mx-xxl-5 px-md-3 pt-md-2 flex-grow-1" >
                    <!-- 用户名 -->
                    <div class="mb-3 mt-3 mt-xl-2 mb-xl-2 mb-md-1 mt-md-1 d-flex align-items-center">
                        <label for="d-flex txtUser w-20" class="login-lbl fs-4">用户名</label>
                        <div class="input-group w-50 ms-5">
                            <!-- <span class="input-group-text border-warning border border-end-0">
                                <i class="bi bi-person-fill fs-4 lh-1 text-black"></i>
                            </span> -->
                            <input type="text" class=" text-black border-dark border-2 border-top-1 ps-1 fw-bold shadow-none w-100 fs-4 p-0 lh-1"  v-model="userName">
                        </div>
                    </div>
                    <!-- 密码 -->
                    <div class="mb-3 mb-xl-2 mb-md-1 d-flex align-items-center">
                        <label for="txtPwd" class="login-lbl fs-4">密&nbsp;&nbsp;码</label>
                        <div class="input-group w-50 ms-5">
                            <!-- <span class="input-group-text border-warning border border-end-0">
                                <i class="bi bi-lock-fill fs-4 lh-1 text-black"></i>
                            </span> -->
                            <input type="password" class="text-black border-dark border-2 border-start-1 ps-1 fw-bold shadow-none w-100 small p-0 lh-lg"  v-model="pwd" autocomplete="false">
                        </div>
                    </div>
                    <!-- 验证码 -->
                    <div v-if="verify==verifyType.code" class="mb-3 mb-xl-2 mb-md-1 d-flex align-items-center">
                        
                            <label for="txtPwd" class="login-lbl fs-4">验证码</label>
                        
                        <div class="input-group w-50 ms-5">
                            <div class="d-flex justify-content-start">
                                <input type="text" class="border-dark border-2 w-50 me-2 fs-4 p-0 lh-1" id="pwd"  v-model="txtCode">
                                <div class="flex-grow-1 d-flex flex-column">
                                    <canvas id="code" class="bg-light rounded-2 w-100 h-0 flex-grow-1" width="0" height="0" @click="code=drawCode($event.target)"></canvas>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex flex-column">
                            <!-- <canvas id="code" class="d-block bg-light rounded-2 w-100 h-0 flex-grow-1" width="0" height="0" @click="code=drawCode($event.target)"></canvas> -->
                        </div>
                    </div>
                    <!-- 验证码 -->
                    <!-- <div v-if="verify==verifyType.code" class="mb-3 mb-lg-2 row">
                        <div class="col-3">
                            <label for="txtPwd" class="login-lbl fs-4">验证码</label>
                        </div>
                        <div class="col-4 ms-3">
                            <input type="text" class="border-dark border-2" id="pwd"  v-model="txtCode">
                        </div>
                        <div class="col-3 d-flex flex-column">
                            <canvas id="code" class="d-block bg-light rounded-2 w-100 h-0 flex-grow-1" width="0" height="0" @click="code=drawCode($event.target)"></canvas>
                        </div>
                    </div> -->
                    <!-- 滑动验证 -->
                    <div v-if="verify==verifyType.slide" class="mb-2 rounded-2">
                        <div id="slideVerify" class="verify-wrap rounded border border-success position-relative"></div>
                    </div>
                    <!-- 游戏模式 -->
                    <!-- <div class="mb-2 text-light">
                        <label>{{$t("login.gameModel")}}</label>
                        <div class="form-check-inline">
                            <input class="form-check-input me-1" type="radio" name="gameModel" :checked="gameModel==GAME_MODEL.normal" @change="changeGameModel(GAME_MODEL.normal)" id="normGame">
                            <label class="form-check-label" for="normGame">{{$t("login.classics")}}</label>
                        </div>
                        <div class="form-check-inline">
                            <input class="form-check-input me-1" type="radio" name="gameModel" :checked="gameModel==GAME_MODEL.tel" @change="changeGameModel(GAME_MODEL.tel)" id="telGame">
                            <label class="form-check-label" for="telGame">{{$t("login.tel")}}</label>
                        </div>
                    </div> -->
                    <!-- 色调选择 -->
                    <!-- <div class="mb-2 text-light">
                        <label>{{$t("login.colorType")}}</label>
                        <div class="form-check-inline">
                            <input class="form-check-input me-1" type="radio" name="colorType" :checked="skin==SKIN_TYPE.normal" id="normColor" @change="changeSkin(SKIN_TYPE.normal)">
                            <label class="form-check-label" for="normColor">{{$t("login.light")}}</label>
                        </div>
                        <div class="form-check-inline">
                            <input class="form-check-input me-1" type="radio" name="colorType" :checked="skin==SKIN_TYPE.darkness" id="darkColor" @change="changeSkin(SKIN_TYPE.darkness)">
                            <label class="form-check-label" for="darkColor">{{$t("login.dark")}}</label>
                        </div>
                    </div> -->
                    <!-- 验证方式 -->
                    <!-- <div class="mb-2 text-light">
                        <label>{{$t("login.verifyType")}}</label>
                        <div class="form-check-inline">
                            <input class="form-check-input me-1" type="radio" name="checkType" :value="verifyType.slide" id="checkSlide" v-model="verify" @change="changeVerify">
                            <label class="form-check-label" for="checkSlide">{{$t("login.slider")}}</label>
                        </div>
                        <div class="form-check-inline">
                            <input class="form-check-input me-1" type="radio" name="checkType" :value="verifyType.code" id="checkCode" v-model="verify" @change="changeVerify">
                            <label class="form-check-label" for="checkCode">{{$t("login.code")}}</label>
                        </div>
                    </div> -->
                    <!-- 线路选择 -->
                    <!-- <div class="mb-3 text-light">
                        <label>{{$t("login.chooseNetwork")}}</label>
                        <div v-for="(item,key,i) in wsList" :key="(item,key,i)" class="form-check-inline">
                            <input class="form-check-input me-1" type="radio" :value="item" v-model="ws" name="wsline" :id="'wsLine_'+i">
                            <label class="form-check-label" :for="'wsLine_'+i">{{key}}</label>
                        </div>
                    </div> -->
                    <!-- 登录按钮 -->
                    <div class="d-flex mt-4 mb-2 mt-lg-2 justify-content-center">
                        <button type="button" class="btn btn-warning btn-block fw-bold me-3 flex-grow-11" @click="login(LOGIN_MODE.normal)">{{$t("login.login")}}</button>
                        <a type="button" class="btn d-flex align-items-center px-3 fs-6 fw-bold text-light text-game" :href="noLoginChatUrl">在线客服</a>
                    </div>
                </form>
                <div class="d-flex flex-column justify-content-end align-items-center mb-2 newgame " style="margin-left: 0.7rem; margin-right: 0.7rem;">
                    <div class="d-flex justify-content-start w-100">
                        <span class="d-flex flex-column text-black mt-1 small">【新品推送】新版老虎机、牛牛、骰子等游戏正在上线。</span>
                    </div>
                    <div class="d-flex justify-content-end w-100">
                        <a class="btn btn-success mt-xl-1 mt-md-0 mx-2 mb-2 px-4 goNewGame fw-bold fs-5" type="button" :href="newPageUrl">马上进入游戏</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="rail-buttom position-absolute bottom-0"></div>
    </div>
</template>
<script>
// import slideVerifyPlug from '@/assets/js/jq-slideVerify.js'
import {COMMAND,RESULT,LAYER_TYPE,IS_DEBUG,USER,LOGIN_MODE,MUTATION_TYPE,GAME_MODEL,SKIN_TYPE,UPDATE_DATE} from "@/assets/js/config.js"
import { useLayer } from '@/assets/js/useLayer';
import { getDeviceType,drawCode,getSystem } from '@/assets/js/common.js'
import chooseLang from "@/components/public/ChooseLang.vue";
export default {
    components: { chooseLang },
    props:{
        quickUserInfo:{
            default:[]
        },//快捷登录用户信息
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
    },
    data() {
        return {
            USER,
            LOGIN_MODE,
            GAME_MODEL,
            SKIN_TYPE,
            verifyType:{//验证类型
                "slide":0,//滑块验证
                "code":1,//验证码验证
            },
            userName: this.quickUserInfo[0]||"",//用户名
            pwd:this.quickUserInfo[1]||"",//密码
            verify:1,//验证方式(默认为滑动验证方式)
            slideVerify:null,//滑动验证实例对象
            txtCode:"",//用户输入的验证码
            code:"",//生成的验证码
            wsList:window[USER].ws,//config中配置的ws列表
            ws:"",//用户选中的ws线路地址
            isFullScreen:false,//是否全屏
            isShowTry:window[USER].isShowTry,//是否显示免费试用按钮
            lastLoginTime:0,//最后登录时间
            newPageUrl:window[USER].newPageUrl,
            noLoginChatUrl:window[USER].noLoginChatUrl,
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        gameModel(){
            return this.$store.state.gameModel;
        },
        skin(){
            return this.$store.state.skin;
        },
        loginModel(){
            return this.$store.state.loginModel;
        },
        isReConnWs(){
            return this.$store.state.isReConnWs;
        }
    },
    created() {
        //设置默认选中第一个ws协议
        for (let key in this.wsList) {
            this.ws=this.wsList[key];
            break;
        }
    },
    mounted() {
        //如果访问登录页面的时候有guid，说明可能是点击浏览器的返回,需要先注销登录，否则可能被推送账号多方登录
        (this.userInfo.guid!="")&&this.$emit('ws-send', COMMAND.all_logout, this.userInfo.id, this.userInfo.guid);
        //绑定回车事件
        document.onkeyup=e=>(e.keyCode==13&&this.login(LOGIN_MODE.normal));
        //初始化滑动验证
        //  this.initSlideVerify();
        this.code=drawCode(document.getElementById("code"));
        //填充测试账号
        (IS_DEBUG&&!this.userName&&!this.pwd)&&this.fillDebugUser();
        console.log("update date:"+UPDATE_DATE);//更新时间
        let lineLay;//网络状态提示layer对象
        addEventListener("offline",()=>{
            if(this.$root.ws){//已有ws对象，直接关闭ws触发ws关闭事件
                this.$root.ws.close();
            }else{//没有ws对象，还没登录就断网，只需要提示
                lineLay = useLayer({str:this.$t("common.networkErr"),type:LAYER_TYPE.confirm,btn:[this.$t("common.ok")],yesFn:(i)=>{
                    layer.close(i);
                }});
            }
        })
        addEventListener("online",()=>{
            if(!this.$root.ws){//没有ws对象，还没登录网络恢复了，关闭断网的提示并提示网络好了
                layer.close(lineLay);
                useLayer({str:this.$t("common.networkConn")});
            }
        })
    },
    unmounted() {
        document.onkeyup=null;//清空回车事件，释放内存并防止在别的页面仍能触发
    },
    methods:{
        drawCode,
        /**
         * 初始化滑动验证
         */
        initSlideVerify(){
            this.slideVerify = new slideVerifyPlug('slideVerify', {
                initText:this.$t("login.slideTip"),
                sucessText:this.$t("login.slideSuccessTip")
            });
        },
        /**
         * 登录
         * @param {LOGIN_MODE} type 登录方式
         */
        login(type){
            //高频验证
            let nowTime=new Date().getTime();
            if(nowTime-this.lastLoginTime<2000){
                useLayer({str:this.$t("login.loginFast")});
                return;
            }
            this.lastLoginTime=nowTime;
            //登录验证
            if(type==LOGIN_MODE.normal){//正常登录
                let reg = /[^a-z|A-Z|0-9|_]/g;//数字字母下划线
                if(this.userName==""){
                    useLayer({str:this.$t("login.userEmpty")});
                    return;
                }else if(reg.test(this.userName)){
                    useLayer({str:this.$t("login.userErr")});
                    return;
                }else if(this.pwd==""){
                    useLayer({str:this.$t("login.pwdEmpty")});
                    return;
                }
            }
            if (this.verify==this.verifyType.slide){//滑动验证
                if(this.slideVerify.slideFinishState == false){//验证没有通过
                    useLayer({str:this.$t("login.slideVerify")});
                    return;
                }
            }else if(this.verify==this.verifyType.code){//验证码验证
                if(this.txtCode!=this.code){
                    useLayer({str:this.$t("login.codeVerify")});
                    return;
                }
            }
            //登录
            let fn=()=>{
                useLayer({
                    type:LAYER_TYPE.load,
                    str:this.$t("login.logining")
                })
                let ws=new WebSocket(this.ws);
                this.$root.ws=ws;
                ws.onopen=()=> {
                    IS_DEBUG&&console.log("连接建立");
                    if(type==LOGIN_MODE.try){//试玩登录要先获取试玩账号
                        this.$emit("ws-send",COMMAND.all_gettryuser,window[USER].tryBelong);
                    }else{//非试玩
                        let command=this.gameModel==GAME_MODEL.normal?COMMAND.all_login:(this.gameModel==GAME_MODEL.tel?COMMAND.tel_login:null);//接口名称
                        this.$store.commit({
                            type:MUTATION_TYPE.setLoginModel,
                            loginModel:type,
                        })
                        this.$emit("ws-send",command, this.userName, this.pwd, getDeviceType(), this.$root.ip.cip,"abcdefg",type);
                    }
                }
                ws.onclose=(e)=>{
                    console.log(e)
                    // if (e.code == 1006) {//用于期望收到状态码时连接非正常关闭 (也就是说, 没有发送关闭帧).
                    // }
                    if (this.$route.name=="login") {//在登录页面
                        layer.closeAll();
                        useLayer({str:this.$t("login.wsError")});
                        this.$root.ws=null;
                    }else{
                        let count=1;
                        this.reConnSocket(count);
                        this.$store.commit({
                            type:MUTATION_TYPE.setCurrVideoLine,
                            currVideoLine:""
                        })
                    }
                }
                this.$root.onMessage();
                this.$emit("ws-msg",(data)=>{
                    switch (data.command) {
                        case COMMAND.all_login:
                        case COMMAND.tel_login:
                            let result=data.result;//登录结果
                            if (result==RESULT.login.success) {
                                let oldGuid=this.userInfo.guid;
                                this.$root.wsSend(COMMAND.all_online, this.userName, data.guid);
                                // this.$emit("ws-send",COMMAND.all_online, this.userName, data.guid);
                                this.$store.commit({
                                    type:MUTATION_TYPE.setUserInfo,
                                    userInfo:{
                                        id:this.userName,
                                        guid:data.guid
                                    }
                                })
                                !oldGuid&&this.$root.goPage("home");
                            }else{
                                if(result!=""&&(Number(result)==RESULT.login.unUser||Number(result)==RESULT.login.unPwd)){
                                    useLayer({str:this.$t("login.loginErr")});
                                }else{
                                    useLayer({str:this.$t("login.loginFail")});
                                }
                                this.$store.commit({
                                    type:MUTATION_TYPE.setLoginModel,
                                    loginModel:null,
                                })
                            } 
                            break;
                        case COMMAND.all_gettryuser:
                            if(data.result==RESULT.getTryUser.success){
                                this.userName=data.userid;
                                this.pwd=data.pwd;
                                this.$store.commit({
                                    type:MUTATION_TYPE.setLoginModel,
                                    loginModel:LOGIN_MODE.try
                                })
                                this.$emit("ws-send",COMMAND.all_login, data.userid, data.pwd, getDeviceType(), this.$root.ip.cip,"abcdefg",LOGIN_MODE.try);
                            }else if(data.result==RESULT.getTryUser.empty){
                                useLayer({str:this.$t("login.unTryUser")});
                            }
                            break;
                    }
                })
            }
            if(this.gameModel==GAME_MODEL.tel){//有游戏模式，即为电话
                if(this.userName&&(this.userName.length<6||this.userName.length>8||!/^\d+$/.test(this.userName))){//用户名小于6位或者大于8位
                    useLayer({type:LAYER_TYPE.confirm,str:this.$t("login.noTelUser")+this.$t("login.isTelUser"),btn:[this.$t("common.yes"),this.$t("common.no")], yesFn(){fn();}});
                    return;
                }
            }
            fn();
        },
        /**
         * socket重连
         */
        reConnSocket(count){
            if(this.$store.state.isReConnWs){
                useLayer({str:this.$t("common.networkReConn")+"("+count+"/30)",type:LAYER_TYPE.load});
                let ws=new WebSocket(this.ws);
                this.$root.ws=ws;
                ws.onopen=()=>{
                    count=0;
                    useLayer({str:this.$t("common.serverConn")});
                    if(this.loginModel==LOGIN_MODE.try){//试玩登录要先获取试玩账号
                        this.$emit("ws-send",COMMAND.all_gettryuser,window[USER].tryBelong);
                    }else{//非试玩
                        let command=this.gameModel==GAME_MODEL.normal?COMMAND.all_login:(this.gameModel==GAME_MODEL.tel?COMMAND.tel_login:null);//接口名称
                        this.$root.wsSend(command, this.userName, this.pwd, getDeviceType(), this.$root.ip.cip,"abcdefg",this.loginModel);
                        // this.$emit("ws-send",command, this.userName, this.pwd, getDeviceType(), this.$root.ip.cip,"abcdefg",this.loginModel);
                    }
                }
                ws.onclose=(e)=>{
                    if(count>30){
                        useLayer({str:this.$t("common.serverReConnErr"),type:LAYER_TYPE.confirm,btn:this.$t("common.ok"),yesFn:(i)=>{
                            layer.close(i);
                        }});
                    }else{
                        setTimeout(() => {
                            this.reConnSocket(++count);
                        }, 3000);
                    }
                }
                ws.onerror=()=>{
                }
                this.$root.onMessage();
            }
        },
        /**
         * 切换验证方式
         */
        changeVerify(){
            if(this.verify==this.verifyType.code){//验证码验证
                this.code=drawCode(document.getElementById("code"));
            }else if(this.verify==this.verifyType.slide){//滑动验证
                this.initSlideVerify();
            }
        },
        /**
         * 改变游戏模式
         */
        changeGameModel(model){
            this.$store.commit({
                type:MUTATION_TYPE.setGameModel,
                gameModel:model
            })
        },
        /**
         * 换肤
         */
        changeSkin(skin){
            this.$store.commit({
                type:MUTATION_TYPE.setSkin,
                skin:skin
            })
        },
        /**
         * 测试模式自动填充用户
         */
        fillDebugUser(){
            this.userName="a13";
            if(getDeviceType()=="h5_phone_4"){
                getSystem()=="ios"&&(this.userName="a11");
                getSystem()=="android"&&(this.userName="a13");
            }
            this.pwd="000000";
            // this.slideVerify.slideFinishState=true;
        }
    },
    watch: {
        /**
         * 监听游戏模式变化
         */
        gameModel(val) {
            if(IS_DEBUG){
                if(val){//电话模式
                    this.userName="888888";
                    this.pwd="888888";
                }else{
                    this.fillDebugUser();
                }
            }
            if(val){//电话模式
                if(this.userName&&(this.userName.length<6||this.userName.length>8||!/^\d+$/.test(this.userName))){
                    useLayer({str:this.$t("login.noTelUser")});
                }
            }
        },
        /**
         * 监听快速登录信息变化
         */
        quickUserInfo:{
            handler(val){
                if(val){
                    val[0]&&(this.userName=val[0]);
                    val[1]&&(this.pwd=val[1]);
                    if(this.userName&&this.pwd){
                        this.$nextTick(()=>{
                            this.slideVerify.slideFinishState=true;
                            this.login(LOGIN_MODE.quick);
                        })
                    }
                }
            },
            immediate:true
        },
        /**
         * 监听语言改变
         */
        // "$i18n.locale"(){
        //     this.verify==this.verifyType.slide&&this.initSlideVerify();//重置滑动避免语言不改变
        // }
    },
}
</script>